module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--bg-42e7aea70b9b3010732e6f342cfa5472.jpg";